import {createStore as _createStore, combineReducers, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';

export default function createGenericStore({reducers, initialState={}}={}) {
  var rootReducer = combineReducers({...reducers});

  var store = _createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(thunk),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
  );

  return store;
};
